import { useCallback, useEffect } from 'react';
/**
 * @description хук для работы клика по плашке;
 * @param {number} duration
 * @param {function} onClick
 * @param {string | number} id
 * @returns {function }
 */
export var useTimeoutClick = function useTimeoutClick(_ref) {
  var duration = _ref.duration,
    onClick = _ref.onClick,
    id = _ref.id;
  var handleOnClick = useCallback(function () {
    onClick(id);
  }, [onClick, id]);
  useEffect(function () {
    if (!duration) return undefined;
    var timeoutId = setTimeout(handleOnClick, duration);
    return function () {
      clearTimeout(timeoutId);
    };
  }, [duration, handleOnClick]);
  return {
    handleOnClick: handleOnClick
  };
};